import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";
import Task from "../models/Task";

class TaskManager extends ManagerBase {
	constructor () {
		super("taskManager");

		this.responsesModelClass = Task;
		this.remoteClassName = "task";
	}

	// close (task) {
	// 	var rd = NousCore.api.createRequest({ item: { guid: task.guid }});
	
	// 	NousCore.api.send("task/close", rd, function (data) {
	// 		console.log(data);
	
	// 		if (data.isSuccess) {
	// 			switch (data.rc) {
	// 				case 1:
	// 					task.parse(data.items[0]);
	
	// 					taskManager.emit("closed");
	// 					taskManager.emit("listChanged");
	// 					break;
	// 				default:
	// 					taskManager.emit("error", data.error);
	// 					break;
	// 			}
	// 		}
	// 	});
	// }
	
	async getByGuidList (guidList) {
		let rd = NousCore.api.createRequest({ item: { guidList } });
		const requestedAction = "get-by-guid-list";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			// console.log({data});

			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const taskList = Shark.getInstanceList(Task, data.items);

						return {
							data: taskList,
							status: "ok"
						};
					}
					default:
						return {
							data,
							status: "ok"
						};
				}
			}
		});
	}

	async getList2 (filters, preventSetGlobalList = false) {
		const { activeItems } = Shark.get();
		const result = await super.getList(null, {
			filters,
			projectGuid: filters.projectGuid,
			// showClosed: activeItems.showClosedTasks,
		});

		if (result?.status === "ok") {
			if (!preventSetGlobalList) {
				Shark.set({
					taskList: result.data,
				});
			}
			taskManager.emit("listChanged");
		}
		else {
			taskManager.emit("error", result);
		}
		
		return result;
	}

	async save (task) {
		var rd = NousCore.api.createRequest({ item: task.export() });
		const action = task.guid === "" ? "insert" : "update";

		return NousCore.api.send("task/" + action, rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						task.import(data.items[0]);
						
						if (action === "insert") {
							Shark.get("taskList").push(task);
						}

						taskManager.emit("saved");
						taskManager.emit("listChanged");
						return {
							data,
							requestedAction: "save",
							status: "ok"
						};
					default:
						taskManager.emit("error", data.error);
						return {
							data,
							requestedAction: "save",
							status: "ok"
						};
				}
			}
		});
	}
}

const taskManager = new TaskManager();

Shark.registerController(taskManager);

export default taskManager;